var map = {
	"./29_car.mp3": "5f16",
	"./30_doll.mp3": "1e0d",
	"./31_ball_.mp3": "b953",
	"./32_robot.mp3": "f63e",
	"./33_one.mp3": "d164",
	"./34_two.mp3": "2ea7",
	"./35_three.mp3": "a36f",
	"./36_sing.mp3": "87cd",
	"./37_catch.mp3": "a148",
	"./38_clap.mp3": "2398",
	"./39_dance.mp3": "5a23",
	"./40_run.mp3": "f7bf",
	"./41_paint.mp3": "ed60",
	"./42_jump.mp3": "d7e6",
	"./M_Brilliant.mp3": "d0b2",
	"./M_Excellent.mp3": "7b0f",
	"./M_Fantastic.mp3": "1323",
	"./M_Great.mp3": "a709",
	"./M_Perfect.mp3": "6d5a",
	"./M_Think again.mp3": "a907",
	"./M_Try again.mp3": "f808",
	"./M_Very good.mp3": "5400",
	"./M_Well done.mp3": "d983",
	"./M_Work harder.mp3": "b92a",
	"./click.mp3": "edfe"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e856";